{
    "UserMenu_Notifications": "Notifiche",
    "UserMenu_UserTour": "Avvia il tour didattico per gli utenti",
    "UserMenu_ShowInsights": "Mostra dashboard approfondimenti",
    "UserMenu_HideInsights": "Nascondi la dashboard di Insights",
    "UserMenu_ChangePassword": "Cambiare la password",
    "UserMenu_ChangeLanguage": "Cambia lingua",
    "UserMenu_Timezone": "Cambia fuso orario",
    "UserMenu_Help": "Aiuto",
    "UserMenu_ClearContentful": "Cancella contenuto cache",
    "UserMenu_ChangeBrowserProfile": "Cambia profilo del browser",
    "UserMenu_Resources": "Risorse",
    "UserMenu_Resources_Terms": "Termini e condizioni",
    "UserMenu_Resources_CookiePolicy": "Informativa sui cookie",
    "UserMenu_Resources_PrivacyPolicy": "politica sulla riservatezza",
    "UserMenu_Logout": "Esci",
    "NAME": "UserMenu"
}